import { RECEIVE_PENSION_CONTRIBUTIONS, REQUEST_PENSION_CONTRIBUTIONS } from '../actions/pension-contributions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_PENSION_CONTRIBUTIONS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_PENSION_CONTRIBUTIONS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
